import { Radio, RadioGroup } from "@nju/form";
import { IScope } from "@nju/scope";
import { Separator } from "@nju/ui";
import { INumberDecisionType } from "./selectNewOrExistingNumber.machine";

interface ISelectNewOrExistingNumberForm {
  handleNumberDecisionMethodChange(value: INumberDecisionType): void;
  variant: IScope;
}

export function SelectNewOrExistingNumberForm({
  handleNumberDecisionMethodChange,
  variant,
}: ISelectNewOrExistingNumberForm) {
  return (
    <form>
      <RadioGroup
        aria-label="number decision method type"
        name="number-decision-method-type"
        onValueChange={(value) => {
          handleNumberDecisionMethodChange(value as INumberDecisionType);
        }}
      >
        <Radio value="EXISTING">
          <div className="whitespace-pre-line">
            {variant !== "sales" &&
              "przenoszę numer lub zmieniam ofertę z nju abonament, na kartę lub Orange"}
            {variant === "sales" &&
              "klient chce przenieść numer od innego operatora lub zmienić ofertę z nju abonament, \n nju na kartę lub Orange"}
          </div>
        </Radio>
        <Separator size="xs" tone="invisible" />
        <Radio value="NEW">
          {variant !== "sales" && "wybieram nowy numer"}
          {variant === "sales" && "klient chce wybrać nowy numer"}
        </Radio>
        <Separator size="xs" tone="invisible" />
      </RadioGroup>
    </form>
  );
}
